import React from 'react';
import { ListGroup } from 'react-bootstrap';

function ContentAlert({ }) {

  return (
    <>
      <ListGroup variant="flush">
        <ListGroup.Item className="text-center text-muted">
          No hay alertas activas.
        </ListGroup.Item>
      </ListGroup>

    </>
  );
}

export default ContentAlert;
